module.exports = __webpack_public_path__ + "img/cqfw4.5cc7884f.png";